import { GlobalPlayerStore, PlayerType } from "../types";

export const getPlayerStore = (type: PlayerType): GlobalPlayerStore => {
  if (typeof window === "undefined") {
    throw new Error("getPlayerStore called on server");
  }

  if (type === PlayerType.Audio) {
    if (!window.audioPlayerStore) {
      throw new Error("audioPlayerStore is not initialized");
    }
    return window.audioPlayerStore;
  }

  if (!window.videoPlayerStore) {
    throw new Error("videoPlayerStore is not initialized");
  }
  return window.videoPlayerStore;
};
